import React from 'react';

import './contentTable2.scss'

import { useState } from 'react';
import Select from 'react-select'

const jobFamilies = [
    { value: 'hr', label: 'Human Resources' },
    { value: 'it', label: 'Information Technologies' },
    { value: 'code', label: 'Software Development' },
    { value: 'pr', label: 'Marketing and PR' },
    { value: 'accounting', label: 'Accounting' }
]

const jobProfiles = [
    { value: 'cc', label: 'Career Counselor'},
    { value: "pr", label: "Payroll Manager"},
    { value: "dei", label: "Director of Diversity"}
]

const competencies = [
    { value: 'communication', label: 'Communication' },
    { value: 'leadership', label: 'Leadership' },
    { value: 'problem-solving', label: 'Problem Solving' },
    { value: 'teamwork', label: 'Teamwork' }
]

const certifications = [
    { value: 'pmp', label: 'Project Management Professional (PMP)' },
    { value: 'shrm-cp', label: 'SHRM Certified Professional (SHRM-CP)' },
    { value: 'cpa', label: 'Certified Public Accountant (CPA)' }
]

const educationLevels = [
    { value: 'high-school', label: 'High School Diploma' },
    { value: 'associate', label: 'Associate Degree' },
    { value: 'bachelor', label: "Bachelor's Degree" },
    { value: 'master', label: "Master's Degree" },
    { value: 'doctorate', label: 'Doctorate' }
]

const workExperience = [
    { value: '0-1', label: 'Less than 1 year' },
    { value: '1-3', label: '1 - 3 years' },
    { value: '3-5', label: '3 - 5 years' },
    { value: '5+', label: '5+ years' }
]

const HiringRestrictions = () => (
    <table>
        <tbody>
            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-availabilityDate'>Availability Date</label></td>
                <td className='req' aria-hidden='true'>*</td>
                <td className='item'>
                    <input className='input date' type='date' id='createPosition-availabilityDate' name='availabilityDate' required aria-required='true'/>
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-earliestHireDate'>Earliest Hire Date</label></td>
                <td className='req' aria-hidden='true'>*</td>
                <td className='item'>
                    <input className='input date' type='date' id='createPosition-earliestHireDate' name='earliestHireDate' required aria-required='true'/>
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-noJobPostingTitle'>No Job Posting Title</label></td>
                <td className='req'></td>
                <td className='item'>
                    <input className='input check' type='checkbox' id='createPosition-noJobPostingTitle' name='noJobPostingTitle'/>
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-jobFamily'>Job Family</label></td>
                <td className='req'></td>
                <td className='item'>
                    <Select className='select' inputId='createPosition-jobFamily' name='jobFamily' options={jobFamilies} maxMenuHeight={80} />
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label' id='createPosition-jobProfilesForJobFamily-label'>Job Profiles for Job Family</td>
                <td className='req'></td>
                <td className='item'>
                    <p className='gray' aria-labelledby='createPosition-jobProfilesForJobFamily-label'>(empty)</p>
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-jobProfile'>Job Profiles for Job Family</label></td>
                <td className='req'></td>
                <td className='item'>
                    <Select className='select' inputId='createPosition-jobProfile' name='jobProfile' options={jobProfiles} maxMenuHeight={80} />
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-jobDescriptionSummary'>Job Description Summary</label></td>
                <td className='req'></td>
                <td className='item'>
                    <textarea rows={3} className='input ta' id='createPosition-jobDescriptionSummary' name='jobDescriptionSummary'></textarea>
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-jobDescription'>Job Description</label></td>
                <td className='req'></td>
                <td className='item'>
                    <textarea rows={7} className='input ta' id='createPosition-jobDescription' name='jobDescription'></textarea>
                </td>
            </tr>
        </tbody>
    </table>
)

const Qualifications = () => (
    <table>
        <tbody>
            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-competencies'>Competencies</label></td>
                <td className='req'></td>
                <td className='item'>
                    <Select className='select' inputId='createPosition-competencies' name='competencies' options={competencies} maxMenuHeight={120} isMulti />
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-certifications'>Certifications</label></td>
                <td className='req'></td>
                <td className='item'>
                    <Select className='select' inputId='createPosition-certifications' name='certifications' options={certifications} maxMenuHeight={120} isMulti />
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-education'>Education</label></td>
                <td className='req'></td>
                <td className='item'>
                    <Select className='select' inputId='createPosition-education' name='education' options={educationLevels} maxMenuHeight={120} />
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-workExperience'>Work Experience</label></td>
                <td className='req'></td>
                <td className='item'>
                    <Select className='select' inputId='createPosition-workExperience' name='workExperience' options={workExperience} maxMenuHeight={120} />
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-skills'>Skills</label></td>
                <td className='req'></td>
                <td className='item'>
                    <input className='input' type='text' id='createPosition-skills' name='skills' placeholder='Comma separated'/>
                </td>
            </tr>

            <tr className='formItem'>
                <td className='label'><label htmlFor='createPosition-responsibilities'>Responsibilities</label></td>
                <td className='req'></td>
                <td className='item'>
                    <textarea rows={5} className='input ta' id='createPosition-responsibilities' name='responsibilities'></textarea>
                </td>
            </tr>
        </tbody>
    </table>
)

const tabs = [
    { id: 'hiring', label: 'Hiring Restrictions', panel: HiringRestrictions },
    { id: 'qual', label: 'Qualifications', panel: Qualifications }
]

const ContentTable = (props) => {
    const [activeTab, setActiveTab] = useState('hiring')
    const Panel = tabs.find(tab => tab.id === activeTab).panel

    return (
        <div className='contentTable2'>
            <div className='tabs' role='tablist'>
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        type='button'
                        role='tab'
                        id={`createPosition-tab-${tab.id}`}
                        aria-controls={`createPosition-panel-${tab.id}`}
                        aria-selected={activeTab === tab.id}
                        className={`${tab.id} ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >{tab.label}</button>
                ))}
            </div>
            <div className='hr'></div>
            <div role='tabpanel' id={`createPosition-panel-${activeTab}`} aria-labelledby={`createPosition-tab-${activeTab}`}>
                <Panel/>
            </div>
        </div>
    )
}

export default ContentTable;
